// extracted by mini-css-extract-plugin
export default {"overlay":"baseModal_overlay__Cqejl","dialog":"baseModal_dialog__2y6ac"};